import script from "./UnavailableView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UnavailableView.vue?vue&type=script&setup=true&lang=ts"

import "./UnavailableView.vue?vue&type=style&index=0&id=212271aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-212271aa"]])

export default __exports__